import React from "react";
import { Link } from "react-router-dom";
import Timer from "../UI/Timer.jsx";

function Card({ profile, extraStyling }) {
  if (extraStyling) {
    return (
      <div
        className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
        style={{ display: "block", backgroundSize: "cover" }}
      >
        <div className="nft__item">
          <div className="author_list_pp">
            <Link
              to={`/author/${profile.authorId}`}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
            >
              <img className="lazy" src={profile.authorImage} alt="" />
              <i className="fa fa-check"></i>
            </Link>
          </div>

          {profile.expiryDate && <Timer expiryDate={profile.expiryDate} />}

          <div className="nft__item_wrap">
            <div className="nft__item_extra">
              <div className="nft__item_buttons">
                <button>Buy Now</button>
                <div className="nft__item_share">
                  <h4>Share</h4>
                  <a href="" target="_blank" rel="noreferrer">
                    <i className="fa fa-facebook fa-lg"></i>
                  </a>
                  <a href="" target="_blank" rel="noreferrer">
                    <i className="fa fa-twitter fa-lg"></i>
                  </a>
                  <a href="">
                    <i className="fa fa-envelope fa-lg"></i>
                  </a>
                </div>
              </div>
            </div>
            <Link to={`/item-details/${profile.nftId}`}>
              <img
                src={profile.nftImage}
                className="lazy nft__item_preview"
                alt=""
              />
            </Link>
          </div>
          <div className="nft__item_info">
            <Link to={`/item-details/${profile.nftId}`}>
              <h4>{profile.title}</h4>
            </Link>
            <div className="nft__item_price">{profile.price} ETH</div>
            <div className="nft__item_like">
              <i className="fa fa-heart"></i>
              <span>{profile.likes}</span>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div className="nft__item">
          <div className="author_list_pp">
            <Link
              to={`/author/${profile.authorId}`}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Creator: Monica Lucas"
            >
              <img className="lazy" src={profile.authorImage} alt="" />
              <i className="fa fa-check"></i>
            </Link>
          </div>

          {profile.expiryDate && <Timer expiryDate={profile.expiryDate} />}

          <div className="nft__item_wrap">
            <div className="nft__item_extra">
              <div className="nft__item_buttons">
                <button>Buy Now</button>
                <div className="nft__item_share">
                  <h4>Share</h4>
                  <a href="" target="_blank" rel="noreferrer">
                    <i className="fa fa-facebook fa-lg"></i>
                  </a>
                  <a href="" target="_blank" rel="noreferrer">
                    <i className="fa fa-twitter fa-lg"></i>
                  </a>
                  <a href="">
                    <i className="fa fa-envelope fa-lg"></i>
                  </a>
                </div>
              </div>
            </div>

            <Link to={`/item-details/${profile.nftId}`}>
              <img
                src={profile.nftImage}
                className="lazy nft__item_preview"
                alt=""
              />
            </Link>
          </div>
          <div className="nft__item_info">
            <Link to={`/item-details/${profile.nftId}`}>
              <h4>{profile.title}</h4>
            </Link>
            <div className="nft__item_price">{profile.price} ETH</div>
            <div className="nft__item_like">
              <i className="fa fa-heart"></i>
              <span>{profile.likes}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Card;
